/**
 * Dropdown Field Type - Common
 *
 * Field-type configuration and the shared lookup-API live binding used by both
 * the inline (inline/dropdown.tsx) and modal (modal/dropdown.tsx) renderers.
 *
 * `getLookupApiFn` is an ES-module live binding: `initDependencies` calls the
 * setter, and both the inline and modal renderers (which import the binding from
 * this module) observe the updated value.
 */

import type { FieldTypeConfig } from '../../components/types';
import { M } from './columnWidths';

// ============================================================================
// Shared lookup-API live binding (set lazily to avoid circular dependencies)
// ============================================================================

// eslint-disable-next-line import/no-mutable-exports
export let getLookupApiFn: ((columnId: string) => unknown) | null = null;

/**
 * Set the getLookupApi function (called from initDependencies to avoid circular deps)
 */
export const setGetLookupApi = (fn: (columnId: string) => unknown): void => {
  getLookupApiFn = fn;
};

// ============================================================================
// Field Type Configuration
// ============================================================================

/**
 * Dropdown field type configuration
 */
export const dropdownFieldType: FieldTypeConfig = {
  placeholder: (label: string) => `Select ${label.toLowerCase()}...`,
  ...M,
};
